import SearchParamsBase from "../../../Elements/SearchParamsBase";
import InputTypesEnum from "../../../Enums/InputTypesEnum";

export default class LookupSearchParams extends SearchParamsBase {
  initialize() {
    this.LookupId = '';
    this.Name = '';
    this.Text = '';
    this.Value = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'LookupId', label: 'LookupId', className: 'col-md-6 col-lg', type: InputTypesEnum.Number },
    { fieldName: 'Name', label: 'Lookup name', className: 'col-md-6 col-lg', type: InputTypesEnum.Text },
    { fieldName: 'Text', label: 'Lookup item text', className: 'col-md-6 col-lg', type: InputTypesEnum.Text },
    { fieldName: 'Value', label: 'Lookup item value', className: 'col-md-6 col-lg', type: InputTypesEnum.Text },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'LookupSearchParams';

}